module.exports = __webpack_public_path__ + "static/media/12B.a331f119.jpg";